import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

// import XLSX from 'xlsx';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';

import cliNuevo from '../functions/clinuevo';
import hacerRX from '../functions/hacerrx';

// "use strict";

//Ajustes
const DetAjustes = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.codigoTipoDoc}</td>
      <td className=''>{elemento.numeroDoc}</td>
      <td className=''>{elemento.eMail}</td>
      <td className=''>{elemento.telefono1}</td>
      <td className=''>{elemento.telefono2}</td>
      <td className=''>{elemento.telefono3}</td>
      <td className=''>{elemento.descrTipoVia1}</td>
      <td className=''>{elemento.numeroTipoVia1}</td>
      <td className=''>{elemento.descrTipoVia2}</td>
      <td className=''>{elemento.numeroTipoVia2}</td>
      <td className=''>{elemento.numeroTipoVia2F}</td>
      <td className=''>{elemento.descrTipoUnd1}</td>
      <td className=''>{elemento.numeroTipoUnd1}</td>
      <td className=''>{elemento.descrTipoUnd2}</td>
      <td className=''>{elemento.numeroTipoUnd2}</td>
      <td className=''>{elemento.nombreBarrio}</td>
      <td className=''>{elemento.observacAB}</td>
      <td className=''>{elemento.descrEstrato}</td>
      <td className=''>{elemento.sexoCliente}</td>
      <td className=''>{elemento.servicio}</td>
      <td className=''>{elemento.tecnologia}</td>
    </tr>
  )
};

const ListaAjustes = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetAjustes elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmClNu extends React.Component {
  state={listArchivo: [], permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  handleChange = async (ev) => {
    // console.log(ev.target.name)
    const updState = (listArchivo) => {
      this.setState({listArchivo, errors: []})
    };

    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      let allTiposDoc = []
      let allTiposCliente = []
      let allGruposAfin = []
      let allSegmento = []
      let allDirmayorRtes = []
      if(fileInput.files.length>0){
        if(this.props.allTiposDoc.allTiposDoc){allTiposDoc = await this.props.allTiposDoc.allTiposDoc}
        if(this.props.allTiposCliente.allTiposCliente){allTiposCliente = await this.props.allTiposCliente.allTiposCliente}
        if(this.props.allGruposAfin.allGruposAfin){allGruposAfin = await this.props.allGruposAfin.allGruposAfin}
        if(this.props.allSegmento.allSegmento){allSegmento = await this.props.allSegmento.allSegmento}
        let argsBuscarDM = {tipoqry: `[
          {$unwind: '$ciudades'},
          {$unwind: '$ciudades.zonas'},
          {$unwind: '$ciudades.zonas.barrios'},
          {$project: {codigoDpto: '$codigoDpto', descrDpto: '$descrDpto', codigoDptoDANE: '$codigoDptoDANE',
            codigoCiudad: '$ciudades.codigoCiudad', nombreCiudad: '$ciudades.nombreCiudad',
            codigoMunicipioDANE: '$ciudades.codigoMunicipioDANE', codigoPostalDANE: '$ciudades.codigoPostalDANE',
            codigoCiudadInterno: '$ciudades.codigoCiudadInterno', codBarrasRdo: '$ciudades.codBarrasRdo',
            codigoZona: '$ciudades.zonas.codigoZona', nombreZona: '$ciudades.zonas.nombreZona',
            codigoBarrio: '$ciudades.zonas.barrios.codigoBarrio', nombreBarrio: '$ciudades.zonas.barrios.nombreBarrio',
            codigoTipoDocT: '$ciudades.zonas.barrios.codigoTipoDocT', numeroDocumT: '$ciudades.zonas.barrios.numeroDocumT',
            descrRecursoT: '$ciudades.zonas.barrios.descrRecursoT', codigoTipoDocR: '$ciudades.zonas.barrios.codigoTipoDocR',
            numeroDocumR: '$ciudades.zonas.barrios.numeroDocumR', descrRecursoR: '$ciudades.zonas.barrios.descrRecursoR'
          }},
        ]`}
        let {data} = await this.props.allDirmayorRtes.refetch(argsBuscarDM)
        allDirmayorRtes = await data.allDirmayorRtes

        let archcsv = ""
        // console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numLineas = 0, linea = 0, listArchivo = []
          lines.forEach(line => {
            if(line&&(numLineas>0||(numLineas===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let contrato = campos[0]
              let nombreCliente = campos[1]
              let apellidoCliente = campos[2]
              let codigoTipoDoc = campos[3]
              let numeroDoc = campos[4]
              let eMail = campos[5]
              let telefono1 = campos[6]
              let telefono2 = campos[7]
              let telefono3 = campos[8]
              let nombreBarrio = campos[20]
              let descrTipoVia1 = campos[11]
              let numeroTipoVia1 = campos[12]
              let descrTipoVia2 = campos[13]
              let numeroTipoVia2 = campos[14]
              let numeroTipoVia2F = campos[15]
              let descrTipoUnd1 = campos[16]
              let numeroTipoUnd1 = campos[17]
              let descrTipoUnd2 = campos[18]
              let numeroTipoUnd2 = campos[19]
              
              let descrEstrato = campos[22]
              let sexoCliente = campos[23]
              let observacAB = campos[24]
              let servicio = campos[25]
              let tecnologia = campos[26].substring(0, campos[26].length).replace(/\r/g,'')

              let codigoTarifa = ""
              let codigoServicio1 = "", codigoServicio2 = ""
              if(tecnologia==="HFC"){
                codigoTarifa = "TPPBSI"
              }
              if(tecnologia==="FTTH"){
                codigoTarifa = "FTTH"
              }
              if(tecnologia==="HFC"&&servicio==="INTERNET + TELEVISION"){
                codigoServicio1 = "MINT"
                codigoServicio2 = "TVES"
              }
              if(tecnologia==="HFC"&&servicio==="INTERNET"){
                codigoServicio1 = "MINT"
              }
              if(tecnologia==="FTTH"&&servicio==="INTERNET + TELEVISION"){
                codigoServicio1 = "MINTU"
                codigoServicio2 = "TVESU"
              }
              if(tecnologia==="FTTH"&&servicio==="INTERNET"){
                codigoServicio1 = "MINTU"
              }

              let observaciones = ""
              let referencia1 = ""
              let telefonoRef1 = ""
              let referencia2 = ""
              let telefonoRef2 = ""

              let nombreBarrioCl = []
              nombreBarrioCl = allDirmayorRtes.filter(elemento => elemento.nombreBarrio===nombreBarrio)

              let _idTipoDoc = "", descrTipoDoc = "", tipoDocCl = []
              tipoDocCl = allTiposDoc.filter(elemento => elemento.codigoTipoDoc===codigoTipoDoc)
              if(tipoDocCl.length>0){
                _idTipoDoc = tipoDocCl[0]._id
                descrTipoDoc = tipoDocCl[0].descrTipoDoc
              }
              let codigoTipoCliente = "", descrTipoCliente = ""
              if(allTiposCliente.length>0){
                codigoTipoCliente = allTiposCliente[0].codigoTipoCliente
                descrTipoCliente = allTiposCliente[0].descrTipoCliente
              }

              let _idGrupoAf = "67a27b5bb8b5e30ddb08c0a6"
              let codigoGrupoAfin = "MT"
              let descrGrupoAfin = "MINTIC"
              // let _idGrupoAf = "", codigoGrupoAfin = "", descrGrupoAfin = ""
              // if(allGruposAfin.length>0){
              //   _idGrupoAf = allGruposAfin[0]._id
              //   codigoGrupoAfin = allGruposAfin[0].codigoGrupoAfin
              //   descrGrupoAfin = allGruposAfin[0].descrGrupoAfin
              // }
              let codigoSegmento = "", descrSegmento = ""
              if(allSegmento.length>0){
                codigoSegmento = allSegmento[0].codigoSegmento
                descrSegmento = allSegmento[0].descrSegmento
              }

              listArchivo.push({linea, contrato, nombreCliente, apellidoCliente, eMail, descrEstrato, sexoCliente,
                codigoTipoDoc, _idTipoDoc, descrTipoDoc, numeroDoc, codigoTipoCliente, descrTipoCliente,
                codigoGrupoAfin, _idGrupoAf, descrGrupoAfin, observaciones, telefono1,
                telefono2, telefono3, referencia1, telefonoRef1, referencia2, telefonoRef2, descrTipoVia1,
                numeroTipoVia1, descrTipoVia2, numeroTipoVia2, numeroTipoVia2F, descrTipoUnd1, numeroTipoUnd1,
                descrTipoUnd2, numeroTipoUnd2, codigoSegmento, descrSegmento,
                nombreBarrio, nombreBarrioCl, servicio, tecnologia,
                codigoTarifa, codigoServicio1, codigoServicio2, observacAB})
            }
            numLineas += 1
          })
          updState(listArchivo)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listArchivo: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listArchivo, empresaArchFE)=>{
    let errors = []
    if(listArchivo.length===0){
      errors.push({path: "Clientes", message: "No hay clientes"});
    }
    for(let ii=0; ii<listArchivo.length; ii++){
      let elemento = listArchivo[ii]
      if(!elemento.contrato||!elemento.nombreCliente||!elemento.apellidoCliente){
        errors.push({path: "Clientes", message: `Contrato, Nombre o Apellido NO EXISTEN en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}, nombreCliente: ${elemento.nombreCliente}, apellidoCliente: ${elemento.apellidoCliente}`});
      }

      if(this.props.allClientes.allClientes){
        let {data} = await this.props.allClientes.refetch({contrato: listArchivo[ii].contrato, numDocum: 1327})
        let allClientes = await data.allClientes
        if(allClientes.length>0){
          errors.push({path: 'contrato', message: `Contrato YA existe en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
        }
      }
      if(!elemento.descrTipoDoc.trim()){
        errors.push({path: 'codigoTipoDoc', message: `Línea No. ${elemento.linea} => El tipo de documento (${elemento.codigoTipoDoc}) no existe en foroptic`});
      }
      if(!elemento.numeroDoc.trim()){
        errors.push({path: 'numeroDoc', message: `Línea No. ${elemento.linea} => El documento no puede ser blanco`});
      }
      if(!elemento.descrEstrato.trim()){
        errors.push({path: 'descrEstrato', message: `Línea No. ${elemento.linea} => El estrato no puede ser blanco`});
      }
      if(!elemento.sexoCliente.trim()||(elemento.sexoCliente!=="Masculino"&&elemento.sexoCliente!=="Femenino")){
        errors.push({path: 'sexoCliente', message: `Línea No. ${elemento.linea} => El sexo (${elemento.sexoCliente}) no existe en foroptic`});
      }
      if(!elemento.descrTipoVia1.trim()){
        errors.push({path: 'descrTipoVia1', message: `Línea No. ${elemento.linea} => El Tipo vía 1 no puede ser blanco`});
      }
      if(!elemento.numeroTipoVia1.trim()){
        errors.push({path: 'numeroTipoVia1', message: `Línea No. ${elemento.linea} => El # Tipo Vía 1 no puede ser blanco`});
      }
      // if(!elemento.descrTipoVia2.trim()){
      //   errors.push({path: 'descrTipoVia2', message: `Línea No. ${elemento.linea} => El Tipo vía 2 no puede ser blanco`});
      // }
      // if(!elemento.numeroTipoVia2.trim()){
      //   errors.push({path: 'numeroTipoVia2', message: `Línea No. ${elemento.linea} => El # Tipo Vía 2 no puede ser blanco`});
      // }
      if(elemento.nombreBarrioCl.length===0){
        errors.push({path: 'nombreBarrio', message: `Línea No. ${elemento.linea} => El Barrio (${elemento.nombreBarrio}) no existe en foroptic`});
      }
      if(elemento.servicio!=="INTERNET + TELEVISION"&&elemento.servicio!=="INTERNET"){
        errors.push({path: 'servicio', message: `Línea No. ${elemento.linea} => El Servicio (${elemento.servicio}) debe ser INTERNET + TELEVISION    o    INTERNET`});
      }
      if(elemento.tecnologia!=="FTTH"&&elemento.tecnologia!=="HFC"){
        errors.push({path: 'tecnologia', message: `Línea No. ${elemento.linea} => La Tecnología (${elemento.tecnologia}) debe ser FTTH    o    HFC`});
      }
    }

    this.setState({errors})
    if(errors.length===0){
      //PROCESO CLIENTES NUEVOS
      document.body.style.cursor = 'wait'

      let checkCrearOS = false
      // if(empresaArchFE==="codisert"){
        checkCrearOS = document.getElementById("checkCrearOS").checked
      // }

      //EL ULTIMO CONTRATO NO DEBE TENER NAS DE UN AJUSTE PORQUE SI TIENE MAS DE UNO,
      //CUANDO ENCUENTRE EL PRIMER AJUSTE Y LO COMPARE CON contratoFinProc FINALIZA EL PROCESO
      let iii = 0, contratoFinProc = listArchivo[listArchivo.length-1].contrato, contratoFin = ""

      const startTime = async (listArchivo, allCli, allDirmayor, allTiposOS, allRecurso, allTarifa, editSeqfindOneAndUpdate, createCliente,
          editClienteUpdDoc, createOdeS, createMovClientesMany, createMovCliCCMany,
          editClienteMany, editClienteUpdDocMany, editOdeSUpdDoc, editCliente, checkCrearOS) => {
        let clienteSel = {}, argsSelDpto = {}

        setTimeout(async ()=>{
          // console.log("paso ajuste")
          if(iii<listArchivo.length){
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha
            if(listArchivo[iii].nombreBarrioCl.length>0&&listArchivo[iii].nombreBarrio){
              let allDirmayorRtes = listArchivo[iii].nombreBarrioCl
              // console.log(allDirmayorRtes.length)
              if(allDirmayorRtes.length>0){
                argsSelDpto = allDirmayorRtes[0]

                if(allCli){
                  let argsBuscar={}
                  argsBuscar.numDocum=1
                  argsBuscar.contrato=null
                  argsBuscar.nombreBarrio=argsSelDpto.nombreBarrio
                  // console.log(argsBuscar)
                  let {data} = await allCli.refetch(argsBuscar)
                  let allClientes = await data.allClientes
                  if(allClientes.length>0){
                    clienteSel = allClientes[0]
                    argsSelDpto['codigoTipoDocT'] = clienteSel.dirmayor.ciudades.zonas.barrios.codigoTipoDocT
                    argsSelDpto['numeroDocumT'] = clienteSel.dirmayor.ciudades.zonas.barrios.numeroDocumT
                    argsSelDpto['descrRecursoT'] = clienteSel.dirmayor.ciudades.zonas.barrios.descrRecursoT
                    argsSelDpto['codigoTipoDocR'] = clienteSel.dirmayor.ciudades.zonas.barrios.codigoTipoDocR
                    argsSelDpto['numeroDocumR'] = clienteSel.dirmayor.ciudades.zonas.barrios.numeroDocumR
                    argsSelDpto['descrRecursoR'] = clienteSel.dirmayor.ciudades.zonas.barrios.descrRecursoR
                    // console.log(argsSelDpto, clienteSel, allClientes.length)
                  }else{
                    if(allDirmayor.allDirmayor){
                      const elemento3 = this.props.allDirmayor.allDirmayor
                      elemento3.forEach((elemento, _id) => {
                        if(elemento.ciudades.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
                          elemento.ciudades.forEach((elemento1, i) => {
                            if(argsSelDpto.codigoCiudad===elemento1.codigoCiudad){
                              elemento1.zonas.forEach((elemento2, i) => {
                                  elemento2.barrios.forEach((elemento3, i) => {
                                    if(elemento3.codigoBarrio){
                                      if(argsSelDpto.nombreBarrio===elemento3.nombreBarrio && argsSelDpto.codigoBarrio===elemento3.codigoBarrio){
                                        argsSelDpto['codigoTipoDocT'] = elemento3.codigoTipoDocT
                                        argsSelDpto['numeroDocumT'] = elemento3.numeroDocumT
                                        argsSelDpto['descrRecursoT'] = elemento3.descrRecursoT
                                        argsSelDpto['codigoTipoDocR'] = elemento3.codigoTipoDocR
                                        argsSelDpto['numeroDocumR'] = elemento3.numeroDocumR
                                        argsSelDpto['descrRecursoR'] = elemento3.descrRecursoR
                                        // console.log(argsSelDpto, elemento3)
                                      }
                                    }
                                  })
                              })
                            }
                          })
                        }
                      })
                    }
                  }
                }
              }
            }
            let lista = []
            let tipoOSIns = {}
            if(allTiposOS.allTiposOS){
              lista = allTiposOS.allTiposOS.filter(elemento => elemento.descrTipoOS==="INSTALACION")
              if(lista.length>0){
                tipoOSIns = lista[0]
                tipoOSIns['_idTipoOS'] = lista[0]._id
              }
            }

            let recurso = []
            // console.log(argsSelDpto.codigoTipoDocT, argsSelDpto.numeroDocumT)
            if(allRecurso.allRecurso){
              recurso = allRecurso.allRecurso.filter(elemento =>
                elemento.codigoTipoDoc===argsSelDpto.codigoTipoDocT&&
                elemento.numeroDocum===argsSelDpto.numeroDocumT)
            }
            let tarifas = [], servicios = [], serviciosIni = []
            let tarifa = {}
            if(allTarifa.allTarifa){
              tarifas = allTarifa.allTarifa.filter(elemento => elemento.codigoTarifa===listArchivo[iii].codigoTarifa)
              if(tarifas.length>0){
                let fechaHoyVence = new Date()
                let fechaV = (fechaHoyVence.getFullYear()+1) + '-' + ((fechaHoyVence.getMonth()+1)<10?'0'+(fechaHoyVence.getMonth()+1):(fechaHoyVence.getMonth()+1)) + '-' + (fechaHoyVence.getUTCDate()<10?'0'+fechaHoyVence.getUTCDate():fechaHoyVence.getUTCDate())
                tarifa = {codigoTarifa: tarifas[0].codigoTarifa, descrTarifa: tarifas[0].descrTarifa, fechaVence: fechaV, cicloFact: tarifas[0].cicloFact}

                serviciosIni = tarifas[0].servicios.filter(elemento => elemento.codigoServicio===listArchivo[iii].codigoServicio1 || elemento.codigoServicio===listArchivo[iii].codigoServicio2)
              }
              // console.log(tarifa, serviciosIni, tarifas[0])
            }


            const numST = serviciosIni.length + 1
            serviciosIni.forEach((elemento, i) => {
              if(elemento.codigoServicio){
                // console.log(elemento)
                let valorServicios = 0
                let valorAntesImptos = 0
                let imptosCF = []
                if(elemento.rango1Valor){
                  valorServicios = Number(elemento.rango1Valor)
                  // if(valorServicios!==null&&valorServicios!==''){
                  //   valorServicios = 0
                  // }
                  let valorI = 0
                  elemento.imptos.forEach((elemento1, _id) => {
                    valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
                    imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                      descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                      valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
                  })
                  valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
                  valorAntesImptos = valorServicios
                  valorServicios += valorI
                  // console.log(valorAntesImptos, valorServicios, valorI)
                }else{
                  imptosCF = elemento.imptos
                }
                servicios.push({codigoTarifa: tarifa.codigoTarifa, descrTarifa: tarifa.descrTarifa,
                  cicloFact: tarifa.cicloFact,
                  codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                  _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
                  descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
                  codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
                  velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
                  codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
                  colorServicio: elemento.colorServicio,
                  rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
                  rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
                  rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
                  rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
                  rango3Valor: elemento.rango3Valor,
                  numeroServicios: '1',
                  valorServicios: valorServicios,
                  valorAntesImptos: valorAntesImptos,
                  _id: i + numST, estadoSelecc: true, imptos: imptosCF
                });
              }
            })

            let contratoAj = await cliNuevo(tarifa, servicios, recurso, listArchivo[iii], argsSelDpto, editSeqfindOneAndUpdate,
              createCliente, editClienteUpdDoc, createOdeS, editOdeSUpdDoc, editCliente, fechaHoraHoy,
              checkCrearOS, tipoOSIns)
            contratoFin = contratoAj.contrato

            await startTime(listArchivo, allCli, allDirmayor, allTiposOS, allRecurso, allTarifa, editSeqfindOneAndUpdate, createCliente,
              editClienteUpdDoc, createOdeS, createMovClientesMany, createMovCliCCMany,
              editClienteMany, editClienteUpdDocMany, editOdeSUpdDoc, editCliente, checkCrearOS)
            // console.log(iii, "contrato ", contratoFin, contratoFinProc)
            if(contratoFin===contratoFinProc){
              
              setTimeout(async () => {
                this.setState({listArchivo: [], errors: []})
                document.body.style.cursor = 'default'
              }, 2000)

              // console.log("timeout fin", iii)
            }

            iii += 1
          } 
        }, 200);
      }
      await startTime(listArchivo, this.props.allClientes, this.props.allDirmayor,
                      this.props.allTiposOS, this.props.allRecurso, this.props.allTarifa,
                      this.props.editSeqfindOneAndUpdate, this.props.createCliente,
                      this.props.editClienteUpdDoc, this.props.createOdeS,
                      this.props.createMovClientesMany, this.props.createMovCliCCMany,
                      this.props.editClienteMany, this.props.editClienteUpdDocMany,
                      this.props.editOdeSUpdDoc, this.props.editCliente, checkCrearOS)

    }
    
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {listArchivo, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let mensaje = "CREAR CLIENTES NUEVOS"
    let imgIcon = "images/archivo_32.png"

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listArchivo, this.props.empresa.empresaArchFE):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Procesar archivo de clientes NUEVOS</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {/* {this.props.empresa.empresaArchFE==="codisert" && */}
                  <div>
                    <Form.Field>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkCrearOS"
                                name="checkCrearOS" defaultChecked={true} onChange={this.handleChange}/>
                        &nbsp;&nbsp;Crear Orden de Servicio de INSTALACION
                      </p>
                    </Form.Field>
                  </div>
                {/* } */}
                
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Clientes:&nbsp;
                  {listArchivo.length}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                      <th className=''>No.</th>  
                      <th className=''>Contrato</th>
                      <th className=''>Nombre(s)</th>
                      <th className=''>Apellido(s)</th>
                      <th className=''>Tipo Doc</th>
                      <th className=''># documento</th>
                      <th className=''>Correo</th>
                      <th className=''>Teléfono 1</th>
                      <th className=''>Teléfono 2</th>
                      <th className=''>Teléfono 3</th>
                      <th className=''>Tipo Vía 1</th>
                      <th className=''># Tipo Vía 1</th>
                      <th className=''>Tipo Vía 2</th>
                      <th className=''># Tipo Vía 2</th>
                      <th className=''># Final Tipo Vía 2</th>
                      <th className=''>Tipo Unidad 1</th>
                      <th className=''># Tipo Unidad 1</th>
                      <th className=''>Tipo Unidad 2</th>
                      <th className=''># Tipo Unidad 2</th>
                      <th className=''>Barrio</th>
                      <th className=''>Observaciones para OS</th>
                      <th className=''>Estrato</th>
                      <th className=''>Sexo</th>
                      <th className=''>Servicio</th>
                      <th className=''>Tecnología</th>
                      </tr>
                    </thead>
                    <ListaAjustes list={listArchivo}/>
                  </table>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),

  graphql(queries.query.allDirmayorRtes, {name:'allDirmayorRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {descrDpto: "123XYZ"}}]`}}}}),
  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allTiposDoc, {name:'allTiposDoc'}),
  graphql(queries.query.allTiposCliente, {name:'allTiposCliente'}),
  graphql(queries.query.allGruposAfin, {name:'allGruposAfin'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.createCliente, {name:'createCliente'}),

  graphql(queries.mutation.editClienteUpdDoc, {name:'editClienteUpdDoc'}),
  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),

  graphql(queries.mutation.createOdeS, {name:'createOdeS'}),
  graphql(queries.mutation.editOdeSUpdDoc, {name:'editOdeSUpdDoc'}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),

  graphql(queries.query.allSegmento, {name:'allSegmento'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcAdmClNu)
